import { combineReducers } from 'redux'
import order from './order.store'

export const rootReducer = combineReducers({
  order,
})
